import moment from 'moment';
import { DATE_FORMAT_DISPLAY, DATE_TIME_FORMAT_DISPLAY, DEFAULT_PLACEHOLDER } from '@helpers';

const formatDateRange = (version: Record<string, unknown> | null | undefined): string => {
  const first = version?.firstRanOn ? moment(version.firstRanOn as string) : null;
  const last = version?.lastRanOn ? moment(version.lastRanOn as string) : null;
  const isFirstValid = first?.isValid() ?? false;
  const isLastValid = last?.isValid() ?? false;

  if (isFirstValid && isLastValid && first!.isSame(last!, 'day')) {
    return `${first!.format(DATE_TIME_FORMAT_DISPLAY)} - ${last!.format('HH:mm')}`;
  }
  if (isFirstValid) return first!.format(DATE_TIME_FORMAT_DISPLAY);
  if (isLastValid) return last!.format(DATE_TIME_FORMAT_DISPLAY);
  if (version?.createdOn) {
    const created = moment(version.createdOn as string);
    return created.isValid() ? created.format(DATE_FORMAT_DISPLAY) : DEFAULT_PLACEHOLDER;
  }
  return DEFAULT_PLACEHOLDER;
};

export default formatDateRange;
